import { useState } from 'react';
import { useSelector } from 'react-redux';

import {
  FlexJustifyCenter,
  StructureLeftRightWrapper
} from '../../../MyTeamBackofficeStyled';

import { LevelZero } from '../../../common/desktop';
import { Position } from '../../../myTeamBackOffice.constants';
import {
  DotLineArrows,
  LevelOne,
  LevelTwo,
  UserVerifications
} from '../../common';
import StructureNav from './StructureNav';

const StructureDesktop = ({ tab }) => {
  const [defaultOpen, setDefaultOpen] = useState(false);

  const { rootTeamMember, rootTeamMemberInfo } = useSelector(
    (store) => store.myTeamBackoffice
  );

  return (
    <>
      <FlexJustifyCenter>
        <LevelZero
          teamMember={rootTeamMember}
          teamMemberInfo={rootTeamMemberInfo}
          tab={tab}
        />
      </FlexJustifyCenter>
      <UserVerifications teamMember={rootTeamMember} />
      <DotLineArrows />
      <StructureLeftRightWrapper
        style={{ marginBottom: '20px', marginTop: 20 }}>
        <div>
          <LevelOne
            teamMember={rootTeamMember?.leftChildUser}
            parentId={rootTeamMember?.id}
            position={Position.L}
          />
          <DotLineArrows disabled={!rootTeamMember?.leftChildUser?.id} />

          <StructureLeftRightWrapper>
            <div>
              <LevelTwo
                teamMember={rootTeamMember?.leftChildUser?.leftChildUser}
                parentId={rootTeamMember?.leftChildUser?.id}
                position={Position.L}
              />
              <DotLineArrows
                disabled={!rootTeamMember?.leftChildUser?.leftChildUser?.id}
              />
              <StructureLeftRightWrapper>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMember?.leftChildUser?.leftChildUser
                        ?.leftChildUser
                    }
                    parentId={rootTeamMember?.leftChildUser?.leftChildUser?.id}
                    position={Position.L}
                  />
                </div>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMember?.leftChildUser?.leftChildUser
                        ?.rightChildUser
                    }
                    parentId={rootTeamMember?.leftChildUser?.leftChildUser?.id}
                    position={Position.R}
                  />
                </div>
              </StructureLeftRightWrapper>
            </div>
            <div>
              <LevelTwo
                teamMember={rootTeamMember?.leftChildUser?.rightChildUser}
                parentId={rootTeamMember?.leftChildUser?.id}
                position={Position.R}
              />
              <DotLineArrows
                disabled={!rootTeamMember?.leftChildUser?.rightChildUser?.id}
              />
              <StructureLeftRightWrapper>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMember?.leftChildUser?.rightChildUser
                        ?.leftChildUser
                    }
                    parentId={rootTeamMember?.leftChildUser?.rightChildUser?.id}
                    position={Position.L}
                  />
                </div>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMember?.leftChildUser?.rightChildUser
                        ?.rightChildUser
                    }
                    parentId={rootTeamMember?.leftChildUser?.rightChildUser?.id}
                    position={Position.R}
                  />
                </div>
              </StructureLeftRightWrapper>
            </div>
          </StructureLeftRightWrapper>
        </div>

        {/* // */}

        <div>
          <LevelOne
            teamMember={rootTeamMember?.rightChildUser}
            parentId={rootTeamMember?.id}
            position={Position.R}
          />
          <DotLineArrows disabled={!rootTeamMember?.rightChildUser?.id} />

          <StructureLeftRightWrapper>
            <div>
              <LevelTwo
                teamMember={rootTeamMember?.rightChildUser?.leftChildUser}
                parentId={rootTeamMember?.rightChildUser?.id}
                position={Position.L}
              />
              <DotLineArrows
                disabled={!rootTeamMember?.rightChildUser?.leftChildUser?.id}
              />
              <StructureLeftRightWrapper>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMember?.rightChildUser?.leftChildUser
                        ?.leftChildUser
                    }
                    parentId={rootTeamMember?.rightChildUser?.leftChildUser?.id}
                    position={Position.L}
                  />
                </div>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMember?.rightChildUser?.leftChildUser
                        ?.rightChildUser
                    }
                    parentId={rootTeamMember?.rightChildUser?.leftChildUser?.id}
                    position={Position.R}
                  />
                </div>
              </StructureLeftRightWrapper>
            </div>
            <div>
              <LevelTwo
                teamMember={rootTeamMember?.rightChildUser?.rightChildUser}
                parentId={rootTeamMember?.rightChildUser?.id}
                position={Position.R}
              />
              <DotLineArrows
                disabled={!rootTeamMember?.rightChildUser?.rightChildUser?.id}
              />
              <StructureLeftRightWrapper>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMember?.rightChildUser?.rightChildUser
                        ?.leftChildUser
                    }
                    parentId={
                      rootTeamMember?.rightChildUser?.rightChildUser?.id
                    }
                    position={Position.L}
                  />
                </div>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMember?.rightChildUser?.rightChildUser
                        ?.rightChildUser
                    }
                    parentId={
                      rootTeamMember?.rightChildUser?.rightChildUser?.id
                    }
                    position={Position.R}
                  />
                </div>
              </StructureLeftRightWrapper>
            </div>
          </StructureLeftRightWrapper>
        </div>
      </StructureLeftRightWrapper>
      <StructureNav setDefaultOpen={setDefaultOpen} defaultOpen={defaultOpen} />
    </>
  );
};

export default StructureDesktop;
